'use strict'

export default [
  {
    name: "benefitDetails",
    fields: [
      { name: "title" },
      { name: "accountable" },
      { name: "measurement", height:3 },
      { name: "actions", height: 3 },
      { name: "baseline" },
      { name: "goal" }
    ]
  }
];



// WEBPACK FOOTER //
// ./views/businessCase/benefitFormDefinition.js